module.exports = __webpack_public_path__ + "img/ic／5.e2729440.png";